import { FC } from 'react';

import { PageMetadata } from '@/shared';

const Metadata: FC = () => <PageMetadata description='Manage Countercyclical settings.' segments={['Settings']} />;

export default Metadata;
